import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import { getSettingsData } from '../reducer';
import { showGlobalConfirm } from '../../System/actions';
import RoleForm from './RoleForm';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { createRole, deleteRole } from '../actions';
import { getResponseError } from '../../../utils/utils';

export default function RoleColumn(props) {
  const { loadData = () => {} } = props;
  const [selected, setSelected] = useState(null);
  const [isShowForm, setIsShowForm] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [createName, setCreateName] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    roleList = [],
    loadingRoleList = false,
    loadingCreateRole = false,
  } = useSelector(getSettingsData);
  useEffect(() => {
    loadData();
  }, []);

  const handleCreateRole = () => {
    dispatch(createRole(createName)).then(() => {
      loadData().then(() => {
        setShowCreate(false);
        setCreateName('');
      });
      successNotification(formatMessage({ id: 'role.create' }), formatMessage({ id: 'role.create.success' }));
    }).catch(response => errorNotification(formatMessage({ id: 'role.create' }), getResponseError(response)));
  };

  const cancel = () => {
    setIsShowForm(false);
  };
  const handleCreate = () => {
    setShowCreate(true);
  };
  const handleEdit = item => event => {
    setSelected(item.id);
    setIsShowForm(true);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'role.delete' }, { name: item.name }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteRole(item.id)).then(() => {
        if (selected === item.id) {
          setSelected(null);
          setIsShowForm(false);
        }
        loadData();
        successNotification(formatMessage({ id: 'role.delete.title' }), formatMessage({ id: 'role.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'role.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const selectedItem = (roleList || []).find(item => item.id === selected);
  const renderDialog = () => (
    <Dialog
      className={classNames('calibration-dialog-container')}
      onClose={() => { setShowCreate(false); }}
      open
    >
      <DialogTitle header={formatMessage({ id: 'role.name.placeholder' })} title={<Icons onClick={() => { setShowCreate(false); }} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content">
        <TextInputWithLabel
          label={formatMessage({ id: 'role.name' })}
          variant="material"
          placeholder={formatMessage({ id: 'role.name.placeholder' })}
          inputProps={{
            value: createName,
            onChange: e => setCreateName(e.target.value),
          }}
        />
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleCreateRole}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" onClick={() => { setShowCreate(false); }}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );

  return (
    <>
      <div className="settings-category frame">
        <Loader global loading={loadingRoleList || loadingCreateRole} />
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'role' })}</div>
          <div className="settings-buttons">
            <Button variant="secondary" onClick={handleCreate}><Icons customIcon icon="plus" /> {formatMessage({ id: 'app.create' })}</Button>
            {showCreate ? renderDialog() : null}
          </div>
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme">
            {roleList && roleList.map((item, key) => (
              <div
                key={key}
                onClick={() => {
                  setSelected(item.id);
                }}
                className={classNames('settings-menu-item', { selected: selected === item.id })}
              >{item.name}
                <div className="edit-and-delete-buttons">
                  <div className="menu-item-button" onClick={handleEdit(item)}><Icons
                    customIcon
                    icon="pencil"
                    width={16}
                    height={16}
                  />
                  </div>
                  <div className="menu-item-button" onClick={handleDelete(item)}><Icons
                    customIcon
                    icon="trash"
                    width={16}
                    height={16}
                  />
                  </div>
                </div>
              </div>
            ))}
            {!roleList || !roleList.length ? (
              <div className="empty-list">
                <div className="empty-list-text">{formatMessage({ id: 'role.not.found' })}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="settings-options frame">
        {!selectedItem && !isShowForm ? (
          <>
            <div className="settings-header">
              <div className="settings-label">{formatMessage({ id: 'role.permission' })}</div>
            </div>
            <div className="settings-form empty-list">
              <div className="empty-list-text">{formatMessage({ id: 'role.select' })}</div>
            </div>
          </>
        ) : null}
        {selectedItem || isShowForm ? <RoleForm key={selectedItem.id} role={selectedItem} loadData={loadData} /> : null}
      </div>
    </>
  );
}
